import { Dropdown } from "primereact/dropdown";
import React, { useEffect, useState } from "react";
import { FaTimes } from "react-icons/fa";
import { FormActions } from "../Stepper/fields/inputField";

const Modal = ({ isOpen, onClose, fields, onSave, loading }) => {
  const initialFormState = fields.reduce((acc, field) => {
    acc[field.name] = field.value || "";
    return acc;
  }, {});

  const [formValues, setFormValues] = useState(initialFormState);
  const [validationErrors, setValidationErrors] = useState({});

  useEffect(() => {
    const newState = fields.reduce((acc, field) => {
      acc[field.name] = field.value || "";
      return acc;
    }, {});
    setFormValues(newState);
  }, [fields]);

  if (!isOpen) return null;

  const handleInputChange = (e, fieldName) => {
    setFormValues({
      ...formValues,
      [fieldName]: e.target.value,
    });
    if (validationErrors[fieldName]) {
      setValidationErrors({
        ...validationErrors,
        [fieldName]: "",
      });
    }
  };

  const handleSave = () => {
    let errors = {};
    fields.forEach((field) => {
      if (!formValues[field.name] && field.disable !== "true") {
        errors[field.name] = `${field.label} is required`;
      }
    });

    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      return;
    }

    onSave(formValues);
  };

  return (
    <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-50 overflow-y-auto">
      <div className="dark:bg-custom-radial bg-[#F6F6F6] px-6 py-5 rounded-lg shadow-lg max-w-sm md:w-1/3  max-h-[90vh] overflow-y-auto w-full text-[rgba(255,255,255,1)]">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-2xl font-semibold text-lightPrimary dark:text-primary-gradient">
            My Profile
          </h2>
          <button
            onClick={onClose}
            className="text-lightPrimary dark:text-darkWaring focus:outline-none"
          >
            <FaTimes fontSize={20} />
          </button>
        </div>

        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleSave();
          }}
        >
          {fields.map((field, index) => (
            <div className="mb-4" key={index}>
              <label
                htmlFor={field.name}
                className="block text-base font-medium text-info dark:text-grey mb-2"
              >
                {field.label}
              </label>

              {field.type === "select" ? (
                <Dropdown
                  value={formValues[field.name]}
                  name={field.name}
                  onChange={(e) => handleInputChange(e, field.name)}
                  required
                  options={field.options}
                  optionLabel="label"
                  placeholder="Select a Currency"
                  className={`p-dropdown w-full bg-transparent border border-info dark:border-gray-300 text-grey rounded-lg rounded-lg focus:border-info
                    ${formValues[field.name] ? "asset_Dropdown" : ""}`}
                  checkmark={true}
                  highlightOnSelect={false}
                />
              ) : (
                <input
                  type={field.type || "text"}
                  placeholder={field.label}
                  id={field.name}
                  value={formValues[field.name]}
                  onChange={(e) => handleInputChange(e, field.name)}
                  disabled={field.disable === "true"}
                  className={`p-3 w-full rounded-lg border border-info dark:border-gray-300 focus:none bg-transparent disabled:cursor-not-allowed ${
                    field.disable === "true"
                      ? "text-gray-700"
                      : "text-info dark:text-grey"
                  }`}
                />
              )}
              {validationErrors[field.name] && (
                <p className="text-expense dark:text-darkWaring text-sm mt-1">
                  {validationErrors[field.name]}
                </p>
              )}
            </div>
          ))}

          <FormActions
            loading={loading}
            onSave={handleSave}
            onCancel={onClose}
            actionType={"Create"}
            className="justify-end"
            submitType="submit"
          />
        </form>
      </div>
    </div>
  );
};

export default Modal;
